import { gsap } from "../gsap/all.js";
import { ScrollTrigger } from "../gsap/ScrollTrigger.js";
import { SplitText } from '../gsap/SplitText'
import { DrawSVGPlugin } from '../gsap/DrawSVGPlugin'
import { Draggable } from '../gsap/Draggable';
import awardsSectionsNav from './awardsSectionsNav';

gsap.registerPlugin(SplitText)
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(DrawSVGPlugin);
gsap.registerPlugin(Draggable);
gsap.config({ nullTargetWarn: false });

gsap.config({
  force3D: true,
})

export default {
  init() {
    if (awardsSectionsNav && typeof awardsSectionsNav.init === 'function') {
      awardsSectionsNav.init();
    }
    
    (function ($) {
      jQuery(document).ready(function ($) {
        const feed = document.getElementById('podcastFeed');
        if (!feed) return; // bail early

        const slider = feed.querySelector('#podcastSlider');
        const track = feed.querySelector('.pb-podcast-feed__scrollbar-track');
        const handle = feed.querySelector('.pb-podcast-feed__scrollbar-handle');

        if (!slider || !track || !handle) return; // secondary guard

        const cards = slider.querySelectorAll('.pb-podcast-feed__card');
        if (!cards.length) return;

        let dragging = false;
        let startX = 0;
        let handleStart = 0;
        let handleWidth = 0;
        let trackWidth = 0;
        let maxScroll = 0;
        let maxLeft = 0;

        // --- Set dynamic widths for cards ---
        function updateCardWidths() {
          const computedStyle = getComputedStyle(slider);
          const paddingLeft = parseFloat(computedStyle.paddingLeft);
          const paddingRight = parseFloat(computedStyle.paddingRight);
          const gap = parseFloat(computedStyle.columnGap || computedStyle.gap || 0);

          let visibleSlides = window.innerWidth < 768 ? 1 : window.innerWidth < 1024 ? 2 : 3;

          const containerWidth =
          slider.clientWidth - paddingLeft - paddingRight - gap * (visibleSlides - 1);

          const cardWidth = containerWidth / visibleSlides;

          cards.forEach(card => {
            card.style.flex = `0 0 ${cardWidth}px`;
          });
        }

        // --- Update scrollbar metrics ---
        function updateMetrics() {
          trackWidth = track.offsetWidth;
          handleWidth = trackWidth / 3;
          maxScroll = slider.scrollWidth - slider.clientWidth;
          maxLeft = trackWidth - handleWidth;
          handle.style.width = `${handleWidth}px`;
        }

        const syncFromScroll = () => {
          if (dragging || maxScroll <= 0) return;
          const ratio = slider.scrollLeft / maxScroll;
          handle.style.transform = `translateX(${ratio * maxLeft}px)`;
        };

        const setScrollFromHandle = (x) => {
          const bounded = Math.max(0, Math.min(x, maxLeft));
          slider.scrollLeft = (bounded / maxLeft) * maxScroll;
          handle.style.transform = `translateX(${bounded}px)`;
        };

        // --- Drag events ---
        handle.addEventListener('pointerdown', (e) => {
          dragging = true;
          startX = e.clientX;
          const matrix = new DOMMatrixReadOnly(getComputedStyle(handle).transform);
          handleStart = matrix.m41;
          handle.setPointerCapture(e.pointerId);
          handle.classList.add('is-dragging');
          document.body.classList.add('no-select');
        });

        handle.addEventListener('pointermove', (e) => {
          if (!dragging) return;
          setScrollFromHandle(handleStart + (e.clientX - startX));
        });

        handle.addEventListener('pointerup', (e) => {
          dragging = false;
          handle.releasePointerCapture(e.pointerId);
          handle.classList.remove('is-dragging');
          document.body.classList.remove('no-select');
        });

        // --- Click track to jump ---
        track.addEventListener('pointerdown', (e) => {
          if (e.target === handle) return;
          const rect = track.getBoundingClientRect();
          setScrollFromHandle(e.clientX - rect.left - handleWidth / 2);
        });

        // --- Sync ---
        slider.addEventListener('scroll', () => requestAnimationFrame(syncFromScroll));
        window.addEventListener('resize', () => {
          updateCardWidths();
          updateMetrics();
          syncFromScroll();
        });

        // --- Init ---
        updateCardWidths();
        updateMetrics();
        syncFromScroll();
      });
    })(jQuery);


    $('.smooth, .smooth a').click(function () {
      if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
        $('.top-bar').removeClass('open');
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
          $('html,body').animate({ scrollTop: target.offset().top - 90 }, 1000); // Set scroll speed here
          return false;
        }
      }
    });

    $(document).on('click', 'a.scrollMe', function (e) {
      const hash = this.hash;
      const $target = $(hash);
      if (!$target.length) return;

      e.preventDefault();

      const headerH = $('.nav-wrap').outerHeight() || 0;
      const top = $target.offset().top - (90 || headerH);
      $('html, body').stop(true).animate({ scrollTop: top }, 600);
    });

    $('.hamburger').on('click', function (event) {
      event.preventDefault();

      $('.top-bar').toggleClass('open');
      $('.brand svg').toggleClass('menu-open');
      $(this).toggleClass('is-active');
    });

    $(document).on('keydown', function (e) {
      if (e.key === 'Escape' && $('.top-bar').hasClass('open')) {
        closeMainNav();
      }
    });

    $(document).on('click', function (e) {
      if (
        $('.top-bar').hasClass('open') &&
        !$(e.target).closest('.top-bar, .hamburger').length
        ) {
        closeMainNav();
    }
  });

    function closeMainNav() {
      $('.top-bar').removeClass('open');
      $('.brand svg').removeClass('menu-open');
      $('.hamburger').removeClass('is-active');
    }

    $('.menu .menu-item a').on('mouseover', function () {
      $(this).parent().siblings().children().addClass('over')
    });

    $('.menu .menu-item a').on('mouseout', function () {
      $(this).parent().siblings().children().removeClass('over')
    });

    $('.play-sizzle').on('click', function () {
      $(this).children().hide()
      $(this).next().show()
      $(this).next().children().get(0).play()
    });

    const nav = document.querySelector('.nav-wrap')
    const header = document.querySelector('header.banner')

    if (nav) {
      let lastState = null

      const applyCompactState = () => {
        const shouldCompact = window.scrollY > 40

        if (lastState === shouldCompact) {
          return
        }

        nav.classList.toggle('mini', shouldCompact)
        if (header) {
          header.classList.toggle('has-solid-nav', shouldCompact)
        }

        lastState = shouldCompact
      }

      applyCompactState()
      window.addEventListener('scroll', applyCompactState, { passive: true })
      window.addEventListener('resize', applyCompactState)
    }

    let down = document.querySelectorAll('.down path');
    let datl = gsap.timeline({ repeat: -1 })
    datl.to(down, { opacity: 0.2, duration: 2, stagger: 0.2, ease: 'power4.out' })


    // Sizzle Image Rotator and Scroll Trigger
    let words = document.querySelectorAll('.outer__sizzle_hero .word-pair')
    let headline = document.querySelector('.outer__sizzle_hero h1')
    let texts = document.querySelectorAll('.outer__sizzle_hero p')
    let shapes = document.querySelectorAll('.shapes')
    let topArray = gsap.utils.toArray(words)
    let tl = gsap.timeline()
    let amp = document.querySelector('.amp')

    gsap.to(headline, { opacity: 1, y: 0, duration: 0.5, ease: 'power4.out' })
    if (texts) {
      gsap.to(texts, { opacity: 1, y: 0, duration: 0.5, ease: 'power4.out' })
    }
    topArray.forEach((ta, i) => {
      tl.to(ta.children, { opacity: 1, y: 0, ease: "slow(0.3, 0.4, false)", stagger: { amount: 0.3 } })
    })
    gsap.to(amp, { opacity: 1, x: 0, delay: 0.3, ease: "slow(0.3, 0.4, false)" })
    gsap.to(shapes, { scale: 1, opacity: 1, stagger: 0.3 }, '-=0.5')

    // 
    
    let mqvideo = document.querySelector('.mqvid');
    const isRfpPage =
    document.body.classList.contains('isrfppage') ||
      document.body.classList.contains('isrfppafe'); // (in case typo exists somewhere)

      if (mqvideo) {
        if (!isRfpPage) {
        // ✅ Normal behavior everywhere else (creates pin-spacer)
        ScrollTrigger.create({
          id: 'sizzleHeroPin',
          trigger: '.outer__sizzle_hero',
          start: 'top top',
          end: 'bottom top',
          // pin: true,
          // pinSpacing: true,
          onEnter: () => mqvideo.play(),
          onEnterBack: () => mqvideo.play(),
          onLeave: () => mqvideo.pause(),
          onLeaveBack: () => mqvideo.pause(),
        });
      } else {
        // ✅ RFP page: no pin => no pin-spacer
        ScrollTrigger.create({
          id: 'sizzleHeroNoPin',
          trigger: '.outer__sizzle_hero',
          start: 'top bottom',
          end: 'bottom top',
          onEnter: () => mqvideo.play(),
          onEnterBack: () => mqvideo.play(),
          onLeave: () => mqvideo.pause(),
          onLeaveBack: () => mqvideo.pause(),
        });
      }
    }

    // Logo Slider
    let logoArr = gsap.utils.toArray('.outer__logo_slider');
    logoArr.forEach((logo, i) => {
      let ltl = gsap.timeline({
        scrollTrigger: {
          trigger: logo,
          start: 'top +=80%',
        },
      })
      ltl.to(logo.querySelector('.inner__logo_slider'), { opacity: 1, y: 0, duration: 1, ease: 'power4.out' })
    });

    // List Boxes

    let lbheadline = document.querySelectorAll('.list-box-wrap h2')
    let lpshapes = document.querySelectorAll('.shapes-sec')
    let libArr = gsap.utils.toArray('.list-box-wrap');
    libArr.forEach((lb, i) => {
      let lbtl = gsap.timeline({
        scrollTrigger: {
          trigger: lbheadline,
          start: 'top -=100%',
        },
      })
      lbtl.to(lbheadline, { opacity: 1, x: 0, duration: 1, ease: 'power4.out' })
      .to(lpshapes, { scale: 1, opacity: 1, stagger: 0.1 }, '-=0.9')
    });

    let mobBreak = window.matchMedia("(max-width: 768px)").matches;
    let dtBreak = window.matchMedia("(min-width: 769px)").matches;
    let screenSize;

    if (mobBreak) {
      screenSize = 'top 75px';
    } else {
      screenSize = 'top 100px';
    }

    window.addEventListener('resize', event => {
      if (mobBreak) {
        screenSize = 'top 75px';
      } else {
        screenSize = 'top 100px';
      }
    })

    // Callout Alt
    let altp = gsap.timeline({
      scrollTrigger: {
        trigger: '.home-cols-wrap',
        pin: true,
        pinSpacing: true,
        scrub: true,
        start: screenSize,
        end: "+=7500",
      },
    })
    altp.to('.alt-frames.full .frame-stack li', { opacity: 1, duration: 1, stagger: 0.2, ease: "power2.in" })
    .to('.alt-frames.full .frame-stack li:nth-child(4)', { opacity: 0, duration: 1, ease: "power2.in" })
    .to('.alt-frames.full .frame-stack li:nth-child(3)', { opacity: 0, duration: 1, ease: "power2.in" })
    .to('.alt-frames.full .frame-stack li:nth-child(2)', { opacity: 0, duration: 1, ease: "power2.in" })
    .to('.alt-frames.full .frame-stack li:nth-child(1) .inner', { opacity: 0, display: 'none', duration: 1, ease: "power2.in" })
    .to('.alt-frames.full .frame-stack li:nth-child(1)', { height: '120px', duration: 1, ease: "power2.in" })
    .to('.alt-frames.full .frame-stack li .logos', { opacity: 1, duration: 1, stagger: 0.2, ease: "power2.in" })
    .to('.alt-frames.second', { opacity: 1, duration: 2, ease: "power2.in" })
    .to('.alt-frames.second', { opacity: 0, duration: 2, ease: "power2.in" })
    .to('.alt-frames.third', { opacity: 1, duration: 2, ease: "power2.in" })
    .to('.alt-frames.full .frame-stack li:nth-child(1)', { opacity: 0, duration: 1, stagger: 0.2, ease: "power2.in" }, '-=4')
    .to('.last-frame .announcement-headline', { opacity: 1, duration: 3, ease: "power2.in" }, '-=12')
    .to('.last-frame .announcement-subheadline', { opacity: 1, duration: 3, ease: "power2.in" }, '-=12')
    .to('.last-frame .bbn-logo', { opacity: 1, duration: 2, ease: "power2.in" }, '-=12')
    .to('.last-frame .announcement-body', { opacity: 1, duration: 3, ease: "back.inOut(1.7)" }, '-=10')

    .addLabel('badgeStart', '+=0.6')
    .fromTo(
      '.last-frame .badge-icon',
      {
        opacity: 0,
        scale: 2.8,
        xPercent: 35,
        yPercent: -50,
        rotation: 6,
        filter: 'blur(6px)',
        transformOrigin: 'center center',
      },
      {
        opacity: 1,
        scale: 1,
        xPercent: 0,
        yPercent: 0,
        rotation: 0,
        filter: 'blur(0px)',
        duration: 1.2,
        ease: 'power3.out',
        onStart: () => {
          gsap.to('.last-frame .bcorp-badge', {
            opacity: 1,
            duration: 0.6,
            ease: 'power2.out',
          });
        },
      },
      'badgeStart'
      )

    .addLabel('bbnHold', '+=0.6')

    .addLabel('bcorpSlide', '+=0.1')

    .to('.bcorp-frame', { opacity: 1, duration: 0, immediateRender: false }, 'bcorpSlide-=0.001')

    .fromTo('.bcorp-frame',
      { xPercent: 100 },
      { xPercent: 0, opacity: 1, duration: 2.4, ease: 'power3.out', immediateRender: false },
      'bcorpSlide'
      )

    .to('.bcorp-frame', { height: '100%', duration: 0.8, ease: 'power2.out' }, '-=1.6')
    .to('.bcorp-frame .bcorp-badge', { opacity: 1, scale: 1, duration: 1.0, ease: "back.out(1.4)" }, 'bcorpSlide+=0.2')
    .to('.bcorp-frame .announcement-headline', { opacity: 1, duration: 0.9, ease: "power2.out" }, 'bcorpSlide+=0.4')
    .to('.bcorp-frame .announcement-subheadline', { opacity: 1, duration: 0.9, ease: "power2.out" }, 'bcorpSlide+=0.6')
    .to('.bcorp-frame .announcement-body', { opacity: 1, duration: 0.9, ease: "power2.out" }, 'bcorpSlide+=0.8')

    .to('.last-frame', { opacity: 0, xPercent: 0, duration: 0 }, 'bcorpSlide+=2.6')

    $('.frame-stack .logos').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 4000,
      responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      ],
    })

    $('.callout-logos').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 4000,
      responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      ],
    }),

    $('.callout-logos-newsslider').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 4000,
      responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 426,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      ],
    }),

    (function ($) {
      $(document).ready(function () {
        var $sliders = $('.js-tc-slider');

        if (!$sliders.length) return;

        $sliders.each(function () {
          var $slider = $(this);

          if ($slider.hasClass('slick-initialized')) return;

          $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            adaptiveHeight: true,
            infinite: false,
            speed: 400,
          });
        });
      });
    })(jQuery);


    $('.feed-slider').each(function () {
      const $slider = $(this);

      $slider.on('init', function (e, slick) {
        slick.slickGoTo(0, true);
        slick.slickPause();
      });

      $slider.slick({
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        arrows: false,
        dots: true,
        autoplay: false,            // start paused
        autoplaySpeed: 4000,
        initialSlide: 0,
        pauseOnHover: true,
        pauseOnFocus: true,
        responsive: [
        {
          breakpoint: 1025,
          settings: { slidesToShow: 1, slidesToScroll: 1 },
        },
        ],
      });

      // Play only when the block is on screen
      const section = $slider.closest('.team-block-rsm')[0];
      if (!section) return;

      let firstEntryHandled = false;
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
              if (!firstEntryHandled) {
                $slider.slick('slickGoTo', 0, true);
                firstEntryHandled = true;
              }
              $slider.slick('slickPlay');
            } else {
              $slider.slick('slickPause');
            }
          });
        },
        { threshold: [0, 0.5, 1] }
        );

      io.observe(section);
    });


    const section = document.querySelector('.cs-cols-home')

if (section) {

  const logos = gsap.utils.toArray('.cs-cols-home .logo')
  const frame2 = document.querySelector('.cs-cols-home .alt-frames.second')
  const frame3 = document.querySelector('.cs-cols-home .alt-frames.third')
  const frame4 = document.querySelector('.cs-cols-home .alt-frames.fourth')

  if (!logos.length || !frame2 || !frame3 || !frame4) return

  const existingTrigger = ScrollTrigger.getById('csHomePin')
  if (existingTrigger) existingTrigger.kill()

  const isMobile = window.matchMedia('(max-width: 768px)').matches

  /* ---------------------------------------
  INITIAL STATES
  --------------------------------------- */

  gsap.set(logos, {
    scale: 1,
    autoAlpha: 0,
    transformOrigin: 'center center',
  })

  gsap.set('.cs-cols-home .logo img', {
    force3D: true,
  })

  gsap.set('.cs-cols-home .second .reveal-mask', { opacity: 1 })
  gsap.set(frame2, { autoAlpha: 0 })
  gsap.set(frame3, { autoAlpha: 0 })
  gsap.set(frame4, { autoAlpha: 0 })

  gsap.set('.cs-cols-home .lg-logos .columns:first-child', {
    x: -120,
    autoAlpha: 0,
  })

  gsap.set('.cs-cols-home .lg-logos .columns:last-child', {
    x: 120,
    autoAlpha: 0,
  })

  /* ---------------------------------------
  TIMELINE
  --------------------------------------- */

  const homeanimtl = gsap.timeline({
    scrollTrigger: {
      id: 'csHomePin',
      trigger: section,
      pin: true,
      scrub: true,
      start: 'top top',
      end: '+=300%',
      anticipatePin: 1,
      invalidateOnRefresh: true,
    },
  })

  /* ---------------------------------------
  LOGO ANIMATION
  --------------------------------------- */

  if (isMobile) {

    /* MOBILE — sequential center flythrough */

    logos.forEach(function(logo, i){

      const start = i * 0.32

      homeanimtl.fromTo(
        logo,
        {
          scale: 0.9,
          autoAlpha: 0,
          yPercent: -20,
        },
        {
          scale: 1.05,
          autoAlpha: 1,
          yPercent: 0,
          ease: 'none',
          duration: 0.28,
        },
        start
      )

      homeanimtl.to(
        logo,
        {
          yPercent: 140,
          autoAlpha: 0,
          ease: 'none',
          duration: 0.35,
        },
        start + 0.22
      )

    })

  } else {

    /* DESKTOP — burst animation */

    const burst = 420

    homeanimtl.to(logos, {
      autoAlpha: 1,
      duration: 0.15,
      ease: 'none',
    }, 0)

    homeanimtl.to(logos, {
      x: (i) => {

        if (i === 2) return 0
        if (i === 0 || i === 4) return -burst * 3.4

        return burst * 3.4
      },

      y: (i) => {

        if (i === 2) return burst * 2
        if (i === 0 || i === 1) return -burst * 1.8

        return 0
      },

      ease: 'none',
      duration: 1.1,

    }, 0)

    homeanimtl.to(logos, {
      autoAlpha: 0,
      duration: 0.25,
      ease: 'none',
    }, 0.85)

  }


  /* ---------------------------------------
  FRAME 2
  --------------------------------------- */

  const frame2Start = isMobile ? (logos.length * 0.32 + 0.35) : 0.18

  homeanimtl.fromTo(
    '.cs-cols-home .second .reveal-mask',
    { opacity: 1 },
    { opacity: 0, duration: 1.2, ease: 'none' },
    frame2Start
  )

  homeanimtl.to(frame2, {
    autoAlpha: 1,
    duration: 0.4,
    ease: 'none',
  }, frame2Start)

  homeanimtl.to(
    '.cs-cols-home .lg-logos .columns:first-child',
    {
      x: 0,
      autoAlpha: 1,
      duration: 0.6,
      ease: 'power2.out',
    },
    frame2Start + 0.45
  )

  homeanimtl.to(
    '.cs-cols-home .lg-logos .columns:last-child',
    {
      x: 0,
      autoAlpha: 1,
      duration: 0.6,
      ease: 'power2.out',
    },
    frame2Start + 0.45
  )

  /* ---------------------------------------
  FRAME 3
  --------------------------------------- */

  const frame3Start = frame2Start + 1.45
  const frame3Exit = frame3Start + 0.45

  homeanimtl.to(frame2, {
    autoAlpha: 0,
    duration: 0.4,
    ease: 'none',
  }, frame3Start)

  homeanimtl.to(frame3, {
    autoAlpha: 1,
    duration: 0.4,
    ease: 'none',
  }, frame3Start)

  homeanimtl.to(frame3, {
    autoAlpha: 0,
    duration: 0.4,
    ease: 'none',
  }, frame3Exit)

  /* ---------------------------------------
  FRAME 4
  --------------------------------------- */

  const frame4Start = frame3Exit + 0.5

  homeanimtl.to(frame4, {
    autoAlpha: 1,
    duration: 0.8,
    ease: 'none',
  }, frame4Start)

  ScrollTrigger.refresh()
}

    // Callout
    let currentIndex = 0
    const panels = Array.from(document.querySelectorAll('.frames'))
    if (panels.length) {
      ScrollTrigger.create({
        trigger: '.cs-cols',
        pin: true,
        pinSpacing: true,
        scrub: true,
        start: '90% 90%',
        end: function () {
          return '+=' + window.innerHeight * panels.length
        },
        toggleClass: 'is-active',
        onEnter: function () {
          panels[0].classList.add('is-active')
        },
        onLeaveBack: function () {
          panels[0].classList.remove('is-active')
        },
        onUpdate: function (self) {
          const previousIndex = currentIndex

          currentIndex = Math.floor(self.progress * panels.length)

          if (previousIndex >= panels.length || currentIndex >= panels.length)
            return

          if (previousIndex !== currentIndex) {
            panels[previousIndex].classList.remove('is-active')
            panels[currentIndex].classList.add('is-active')
          }
        },
      })
    }

    let lg = document.querySelectorAll('.left-graphic')
    if (lg.length > 0) {
      ScrollTrigger.create({
        trigger: '.left-graphic',
        pin: true,
        scrub: true,
        start: 'top -=200px',
        end: function () {
          return '+=' + window.innerHeight * panels.length
        },
        toggleClass: 'is-active',
        onEnter: function () {
          document.querySelector('.left-graphic').classList.add('is-active')
        },
        onLeaveBack: function () {
          document.querySelector('.left-graphic').classList.remove('is-active')
        },
        onUpdate: function (self) {
          const previousIndex = currentIndex

          currentIndex = Math.floor(self.progress * panels.length)

          if (previousIndex >= panels.length || currentIndex >= panels.length)
            return

          if (previousIndex !== currentIndex) {
            panels[previousIndex].classList.remove('is-active')
            panels[currentIndex].classList.add('is-active')
          }
        },
      })
    }

    // Work Feed Title

    const workTitle = new SplitText('h2.hdl', { type: 'chars' })
    let wtl = gsap.timeline({
      scrollTrigger: {
        trigger: '.wf-wrap',
        start: 'top +=80%',
      },
    })
    wtl.from(workTitle.chars, { duration: 1, opacity: 0, stagger: 0.03, ease: "power2.in" })

    // Work Feed Banners
    var bpl = window.matchMedia("(min-width: 1024px)")
    if (bpl.matches) {
      let wfArr = gsap.utils.toArray('.work-feed');
      setTimeout(() => {
        wfArr.forEach((wf, i) => {
          let video = document.querySelectorAll('.work-vid')
          let wftl = gsap.timeline({
            scrollTrigger: {
              trigger: wf,
              start: 'top center',
              onEnter: () => video[i].play(),
              onEnterBack: () => video[i].play(),
              onLeave: () => video[i].pause(),
              onLeaveBack: () => video[i].pause(),
            },
          })
          // wftl.to(wf.querySelector('.logo'), { width: '220px', duration: 0.50, ease: "power2.in" })
          let block = wf.closest('.work-feed__block');
          let logo = wf.querySelector('.logo');
          let logoWidth;

          if (window.innerWidth < 767) {
            logoWidth = '120px';
          } else {
            // Desktop: vary by size class
            if (block && block.classList.contains('size-100')) {
              logoWidth = '220px';
            } else if (block && block.classList.contains('size-50')) {
              logoWidth = '180px';
            } else if (block && block.classList.contains('size-25')) {
              logoWidth = '120px';
            }
          }

          wftl.to(logo, { width: logoWidth, duration: 0.5, ease: "power2.in" })
          .to(wf.querySelector('.featured-title'), { fontSize: '6rem', duration: 0.50, ease: "power2.in" }, '-=0.55')
          .to(wf.querySelector('.snippet'), { fontSize: '2rem', opacity: 1, duration: 0.50, ease: "power2.in" }, '-=0.55')
        });
      }, 100)
    }

    // only run on target pages
    if (document.body.matches('.home, .hello-rsm')) {
      const mm = gsap.matchMedia();

      // runs when viewport is >= 1024px, and auto-cleans when it isn't
      mm.add("(min-width: 1024px)", () => {
        const ctx = gsap.context(() => {
          const feeds = gsap.utils.toArray('.work-feed');

          ScrollTrigger.addEventListener("load", () => ScrollTrigger.refresh());
          window.addEventListener("load", () => ScrollTrigger.refresh());

          feeds.forEach((wf) => {
            const videoEl = wf.querySelector('.work-vid');

            const tl = gsap.timeline({
              scrollTrigger: {
                trigger: wf,
                start: 'top center',
                id: 'wf-feed',
                onEnter: () => videoEl && videoEl.play(),
                onEnterBack: () => videoEl && videoEl.play(),
                onLeave: () => videoEl && videoEl.pause(),
                onLeaveBack: () => videoEl && videoEl.pause(),
              },
              defaults: { overwrite: 'auto' },
            });

            tl.to(wf.querySelector('.logo'), { width: '220px', duration: 0.5, ease: "power2.in" })
            .to(wf.querySelector('.featured-title'), { fontSize: '6rem', duration: 0.5, ease: "power2.in" }, '-=0.55')
            .to(wf.querySelector('.snippet'), { fontSize: '2rem', opacity: 1, duration: 0.5, ease: "power2.in" }, '-=0.55');
          });
          ScrollTrigger.refresh();
        });

        return () => {
          ctx.revert();
          ScrollTrigger.refresh();
        };
      });

      let rAF;
      window.addEventListener('resize', () => {
        if (window.matchMedia("(min-width: 1024px)").matches) {
          cancelAnimationFrame(rAF);
          rAF = requestAnimationFrame(() => ScrollTrigger.refresh());
        }
      });
    }

    // only run on target pages
    if (document.body.matches('.isrfppage')) {
      const mm = gsap.matchMedia();
      mm.add("(min-width: 1024px)", () => {
        const ctx = gsap.context(() => {
          const feeds = gsap.utils.toArray('.work-feed');

          feeds.forEach((wf) => {
            const videoEl = wf.querySelector('.work-vid');
            gsap.timeline({
              scrollTrigger: {
                trigger: wf,
                start: 'top center',
                onEnter: () => { if (videoEl && videoEl.play) videoEl.play(); },
                onEnterBack: () => { if (videoEl && videoEl.play) videoEl.play(); },
                onLeave: () => { if (videoEl && videoEl.pause) videoEl.pause(); },
                onLeaveBack: () => { if (videoEl && videoEl.pause) videoEl.pause(); },
              },
              defaults: { overwrite: 'auto' },
            })
            .to(wf.querySelector('.logo'), { width: '400px', duration: 0.5, ease: "power2.in" })
            .to(wf.querySelector('.featured-title'), { fontSize: '6rem', duration: 0.5, ease: "power2.in" }, '-=0.55')
            .to(wf.querySelector('.snippet'), { opacity: 1, duration: 0.5, ease: "power2.in" }, '-=0.55');
          });

          ScrollTrigger.refresh();
        });
        return () => ctx.revert();
      });
    }


    // Awards

    let awArr = gsap.utils.toArray('.awards');
    awArr.forEach((aw, i) => {
      let awtl = gsap.timeline({
        scrollTrigger: {
          trigger: aw,
          start: 'top +=70%',
        },
      })
      awtl.to(aw.querySelector('.aw-headline'), { opacity: 1, duration: 0.75, ease: "power2.in" })
      .to(aw.querySelector('.aw-img'), { opacity: 1, duration: 0.75, ease: "power2.in" }, '-=0.75')
      .to(aw.querySelector('.aw-snippet'), { opacity: 1, y: -50, duration: 0.75, ease: "power2.in" }, '-=0.50')
    });

    // Awards New

    let awnArr = gsap.utils.toArray('.awards-new');
    awnArr.forEach((awn, i) => {
      let awntl = gsap.timeline({
        scrollTrigger: {
          trigger: awn,
          start: 'top +=70%',
        },
      })
      awntl.to(awn.querySelector('.awn-headline'), { scale: 0.65, duration: 0.75, ease: "power2.in" })
      .to(awn.querySelector('.awn-snippet'), { opacity: 1, y: -50, duration: 0.75, ease: "power2.in" }, '-=0.50')
    });

    // Awards-Dark stagger logos
    const grids = document.querySelectorAll('.js-aw-logos');
    if (grids.length) {
      const obs = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-inview');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.25 });

      grids.forEach((g) => obs.observe(g));
    }

    // Split
    let splitArr = gsap.utils.toArray('.fifty-split');
    splitArr.forEach((sp, i) => {
      let sptl = gsap.timeline({
        scrollTrigger: {
          trigger: sp,
          start: 'top +=60%',
        },
      })
      sptl.to(sp.querySelector('h2'), { opacity: 1, y: 0, duration: 1, ease: 'power4.out' })
      sptl.to(sp.querySelector('img'), { opacity: 1, y: 0, duration: 1, ease: 'power4.out' }, '-=0.95')
      sptl.to(sp.querySelectorAll('h3'), { opacity: 1, y: 0, duration: 1, ease: 'power4.out' }, '-=0.95')
      sptl.to(sp.querySelectorAll('p'), { opacity: 1, y: 0, duration: 1, ease: 'power4.out' }, '-=0.95')
      sptl.to(sp.querySelectorAll('a'), { opacity: 1, y: 0, duration: 1, ease: 'power4.out' }, '-=0.95')
    });

    // Logo Block
    let lbArr = gsap.utils.toArray('.logo-block');
    lbArr.forEach((lb, i) => {
      let lbtl = gsap.timeline({
        scrollTrigger: {
          trigger: lb,
          start: 'top +=60%',
        },
      })
      lbtl.to(lb.querySelector('h2'), { opacity: 1, y: 0, duration: 1, ease: 'power4.out' })
      lbtl.to(lb.querySelectorAll('.logo'), { opacity: 1, y: 0, duration: 1, ease: 'power4.out', stagger: 0.1 }, '-=0.95')
    });

    // Team Feed
    let tfArr = gsap.utils.toArray('.team-feed');
    tfArr.forEach((tf, i) => {
      let tftl = gsap.timeline({
        scrollTrigger: {
          trigger: tf,
          start: 'top +=60%',
        },
      })
      tftl.to(tf.querySelector('h2'), { opacity: 1, y: 0, duration: 1, ease: 'power4.out' })
      tftl.to(tf.querySelectorAll('.profile'), { opacity: 1, y: 0, duration: 1, ease: 'power4.out', stagger: 0.1 }, '-=0.95')
    });

    // News Feed
    let nfArr = gsap.utils.toArray('.news-feed');
    nfArr.forEach((nf, i) => {
      let nftl = gsap.timeline({
        scrollTrigger: {
          trigger: nf,
          start: 'top +=60%',
        },
      })
      nftl.to(nf.querySelector('h2'), { opacity: 1, y: 0, duration: 1, ease: 'power4.out' })
      nftl.to(nf.querySelectorAll('.news'), { opacity: 1, y: 0, duration: 1, ease: 'power4.out', stagger: 0.1 }, '-=0.95')
      nftl.to(nf.querySelectorAll('a'), { opacity: 1, y: 0, duration: 1, ease: 'power4.out' }, '-=0.95')
    });

    // Logo Grid
    let lgArr = gsap.utils.toArray('.outer__logo_grid');
    lgArr.forEach((lg, i) => {
      let lgtl = gsap.timeline({
        scrollTrigger: {
          trigger: lg,
          start: 'top +=60%',
        },
      })
      lgtl.to(lg.querySelector('h2'), { opacity: 1, y: 0, duration: 1, ease: 'power4.out' })
      .to(lg.querySelectorAll('p'), { opacity: 1, y: 0, duration: 1, ease: 'power4.out' }, '-=0.95')
      .to(lg.querySelectorAll('.logo'), { opacity: 1, y: 0, duration: 1, ease: 'power4.out', stagger: 0.2 }, '-=0.95')
    });

    // Grid Card
    let gcArr = gsap.utils.toArray('.outer__card_grid');
    gcArr.forEach((gc, i) => {
      let gctl = gsap.timeline({
        scrollTrigger: {
          trigger: gc,
          start: 'top +=60%',
        },
      })
      gctl.to(gc.querySelectorAll('.card_grid__item'), { opacity: 1, duration: 1, ease: 'power4.out', stagger: 0.1 })
    });

    // Full Width Banner
    let vmArr = gsap.utils.toArray('.fw-banner');
    vmArr.forEach((vm, i) => {
      let vmtl = gsap.timeline({
        scrollTrigger: {
          trigger: vm,
          start: 'top center',
        },
      })
      vmtl.to(vm.querySelector('h2'), { opacity: 1, y: 0, duration: 1, ease: 'power4.out' })
      .to(vm.querySelectorAll('p'), { opacity: 1, y: 0, duration: 1, ease: 'power4.out' }, '-=0.85')
    });

    // Split Steps
    let ssArr = gsap.utils.toArray('.split-steps');
    ssArr.forEach((ss, i) => {
      let sstl = gsap.timeline({
        scrollTrigger: {
          trigger: ss,
          start: 'top +=60%',
        },
      })
      sstl.to(ss.querySelector('h2'), { opacity: 1, y: 0, duration: 1, ease: 'power4.out' })
      .to(ss.querySelectorAll('p'), { opacity: 1, y: 0, duration: 1, ease: 'power4.out' }, '-=1')
      .to(ss.querySelectorAll('.cols'), { opacity: 1, y: 0, duration: 1, ease: 'power4.out', stagger: 0.1 }, '-=0.95')
      .to(ss.querySelector('.grid-decoration'), { height: '450px', maxWidth: '375px', duration: 1, ease: 'power4.out' }, '-=0.95')
    });


    gsap.utils.toArray('.step').forEach(step => {
      ScrollTrigger.create({
        trigger: step,
        start: 'center 95%',
        end: 'center top',
        toggleClass: 'active',
      });
    });

    // Large List
    let lgsArr = gsap.utils.toArray('.large-split-list');
    lgsArr.forEach((ls, i) => {
      let lgstl = gsap.timeline({
        scrollTrigger: {
          trigger: ls,
          start: 'top +=70%',
        },
      })
      lgstl.to(ls.querySelector('h2'), { opacity: 1, y: 0, duration: 1, ease: 'power4.out' })
      .to(ls.querySelectorAll('p'), { opacity: 1, y: 0, duration: 1, ease: 'power4.out' }, '-=0.85')
      .to(ls.querySelectorAll('.step p'), { opacity: 1, x: 0, duration: 1, ease: 'power4.out', stagger: 0.2 }, '-=0.95')
    });


    gsap.utils.toArray('.step').forEach(step => {
      ScrollTrigger.create({
        trigger: step,
        start: 'center 95%',
        end: 'center top',
        toggleClass: 'active',
      });
    });

    // Two Col Boxes
    let twbArr = gsap.utils.toArray('.two-col-boxes');
    twbArr.forEach((twb, i) => {
      let twbtl = gsap.timeline({
        scrollTrigger: {
          trigger: twb,
          start: 'top +=60%',
        },
      })
      twbtl.to(twb.querySelector('h2'), { opacity: 1, y: 0, duration: 1, ease: 'power4.out' })
      .to(twb.querySelectorAll('.box'), { opacity: 1, y: 0, duration: 1, ease: 'power4.out', stagger: { each: 0.3 } }, '-=0.95')
    });

    // Content Blocks
    let cbArr = gsap.utils.toArray('.outer__content_blocks');
    cbArr.forEach((blk, i) => {
      let lotl = gsap.timeline({
        scrollTrigger: {
          trigger: blk,
          start: 'top center',
        },
      })
      lotl.to(blk.querySelector('.inner__content_blocks'), { opacity: 1, y: 0, duration: 1, ease: 'power4.out' })
    });

    // Pinned Marquee
    let pinpanelsIndex = 0
    const pinpanels = Array.from(document.querySelectorAll('.panels__item'))
    if (pinpanels.length) {
      ScrollTrigger.create({
        trigger: '.pin-container',
        pin: true,
        scrub: true,
        pinSpacing: true,
        end: function () {
          return '+=' + window.innerHeight * pinpanels.length
        },
        toggleClass: 'is-active',
        onEnter: function () {
          pinpanels[0].classList.add('is-active')
        },
        onLeaveBack: function () {
          pinpanels[0].classList.remove('is-active')
        },
        onUpdate: function (self) {
          const previousIndex = pinpanelsIndex

          pinpanelsIndex = Math.floor(self.progress * pinpanels.length)

          if (previousIndex >= pinpanels.length || pinpanelsIndex >= pinpanels.length)
            return

          if (previousIndex !== pinpanelsIndex) {
            pinpanels[previousIndex].classList.remove('is-active')
            pinpanels[pinpanelsIndex].classList.add('is-active')
          }
        },
      })
    }


    // Buckets 
    let icbArr = gsap.utils.toArray('.buckets');
    icbArr.forEach((icb, i) => {
      let icbtl = gsap.timeline({
        scrollTrigger: {
          trigger: icb,
          start: 'top +=60%',
        },
      })
      icbtl.to(icb.querySelectorAll('.bucket'), { opacity: 1, y: 0, duration: 1, stagger: 0.15, ease: 'power4.out' })
    });

    // BCorp Parallax
    gsap.utils.toArray('.bcorp-frame').forEach((section) => {
      const img = section.querySelector('.bcorp-bg img');
      if (!img) return;

      gsap.set(img, { top: "50%", yPercent: -50 });

      gsap.fromTo(
        img,
        { yPercent: -70 },
        {
          yPercent: -30,
          ease: "none",
          scrollTrigger: {
            trigger: section,
            start: "top bottom",
            end: "bottom top",
            scrub: 0.8,
            invalidateOnRefresh: true,
          },
        }
        );
    });

    window.addEventListener('load', () => ScrollTrigger.refresh());

    // Work Slider

    $('.l-slides').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      dots: false,
      autoplay: false,
      autoplaySpeed: 0,
      speed: 5000,
      cssEase: 'linear',
      responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      ],
    })

    const logoSlider = document.querySelector('.l-slides');

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          $('.l-slides').slick('slickPlay');
        } else {
          $('.l-slides').slick('slickPause');
        }
      },
      {
        threshold: 0.1,
      }
      );

    if (logoSlider) {
      observer.observe(logoSlider);
    }


    // Testimonial Slider

    $('.quotes').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      arrows: true,
      dots: false,
    })

    //Awards Slider

    $('.award-slides').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 3000,
      responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      ],
    })
    const el = document.querySelector('.js-hero-text');

    if (el) {
      const split = new SplitText(el, {
        type: "lines, words, chars",
        tag: "span",
        linesClass: "split-text-line",
        wordsClass: "split-text-word",
        charsClass: "split-text-char",
      });

      gsap.from(split.chars, {
        opacity: 0,
        y: 50,
        filter: "blur(8px)",
        duration: 1.4,
        ease: "power3.out",
        stagger: 0.04,
        onComplete: () => {
          gsap.set(split.chars, { clearProps: "all" });
          gsap.set(split.words, { clearProps: "all" });
          gsap.set(split.lines, { clearProps: "all" });
          split.revert();
        },
      });
    }

    const orb = document.querySelector('.js-orb');
    const orb2 = document.querySelector('.js-orb2');

    if (orb) {

      const orbtl = gsap.timeline({
        paused: true,
        repeat: -1,
        yoyo: true,
      });

      orbtl.to(orb, {
        yPercent: 15,
        duration: 6,
        ease: "sine.inOut",
      });

      orbtl.to(orb, {
        scale: 1.14,
        opacity: 0.85,
        duration: 4,
        ease: "power2.inOut",
      }, 0);

      orbtl.to(orb, {
        filter: "blur(6px)",
        duration: 3.5,
        ease: "sine.inOut",
      }, 0);

      orbtl.to(orb, {
        yPercent: 17,
        duration: 3,
        ease: "power1.inOut",
      }, 0);

      ScrollTrigger.create({
        trigger: ".pb-blog-feed__list",
        start: "top center",
        onEnter: () => orbtl.play(),
      });
    }

    if (orb2) {

      const orb2tl = gsap.timeline({
        paused: true,
        repeat: -1,
        yoyo: true,
      });

      orb2tl.to(orb2, {
        right: 0,
        duration: 2.2,
        ease: "power3.out",
      });

      orb2tl.to(
        orb2,
        {
          scale: 1.12,
          opacity: 0.85,
          filter: "blur(6px)",
          duration: 3.5,
          ease: "power2.inOut",
        },
        "-=0.8"
        );

      orb2tl.to(orb2, {
        yPercent: 20,
        duration: 4,
        ease: "sine.inOut",
      });

      orb2tl.to(orb2, {
        yPercent: 35,
        duration: 5,
        ease: "sine.inOut",
      });

      orb2tl.to(orb2, {
        yPercent: 50,
        duration: 6,
        ease: "power1.inOut",
      });

      ScrollTrigger.create({
        trigger: ".pb-blog-feed__list",
        start: "top center",
        onEnter: () => orb2tl.play(),
      });
    }

    // WOPR Video Section
    const woprVideos = document.querySelectorAll('.js-wopr-video');

    woprVideos.forEach((video) => {
      const playButton = video.querySelector('.js-wopr-video-play');
      const template = video.querySelector('.js-wopr-video-template');

      if (!playButton || !template) return;

      const posterHTML = playButton.outerHTML;
      const embedTemplateHTML = template.innerHTML;

      function addAutoplayToIframe(html) {
        const wrapper = document.createElement('div');
        wrapper.innerHTML = html.trim();

        const iframe = wrapper.querySelector('iframe');

        if (iframe) {
          let src = iframe.getAttribute('src') || '';

          if (src) {
            const separator = src.includes('?') ? '&' : '?';

            if (!src.includes('autoplay=1')) {
              src += `${separator}autoplay=1`;
            }

            if (src.includes('youtube.com') || src.includes('youtu.be')) {
              const sep2 = src.includes('?') ? '&' : '?';

              if (!src.includes('mute=1')) {
                src += `${sep2}mute=1`;
              }

              if (!src.includes('playsinline=1')) {
                src += '&playsinline=1';
              }
            }

            iframe.setAttribute('src', src);
          }

          iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
        }

        return wrapper.innerHTML;
      }

      function bindPlay() {
        const currentPlayButton = video.querySelector('.js-wopr-video-play');

        if (currentPlayButton) {
          currentPlayButton.addEventListener('click', playVideo);
        }
      }

      function playVideo() {
        const embedHTML = addAutoplayToIframe(embedTemplateHTML);

        video.innerHTML = `
          <div class="wopr-video-section__embed js-wopr-video-embed">
            ${embedHTML}
          </div>
        `;

        const html5Video = video.querySelector('video');

        if (html5Video) {
          html5Video.play();
        }
      }

      function resetVideo() {
        if (!video.querySelector('.js-wopr-video-embed')) return;

        video.innerHTML = `
          ${posterHTML}
          <template class="js-wopr-video-template">
            ${embedTemplateHTML}
          </template>
        `;

        bindPlay();
      }

      bindPlay();

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              resetVideo();
            }
          });
        },
        {
          threshold: 0.15,
        }
      );

      observer.observe(video);
    });


    // WOPR pinned screens - desktop only
    const woprScreens = document.querySelectorAll('.js-wopr-screens');

    woprScreens.forEach((section) => {
      const triggers = section.querySelectorAll('.js-wopr-screen-trigger');
      const images = section.querySelectorAll('.js-wopr-screen-image');

      if (!triggers.length || !images.length) return;

      function setActive(index) {
        triggers.forEach((trigger) => {
          trigger.classList.toggle('is-active', trigger.dataset.screen === String(index));
        });

        images.forEach((image) => {
          image.classList.toggle('is-active', image.dataset.screen === String(index));
        });
      }

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          setActive(trigger.dataset.screen);
        });
      });

      const mm = gsap.matchMedia();

      mm.add('(min-width: 1024px)', () => {
        const st = ScrollTrigger.create({
          trigger: section,
          start: 'top top',
          end: () => `+=${window.innerHeight * 0.7 * (triggers.length - 1)}`,
          pin: true,
          pinSpacing: true,
          scrub: true,
          invalidateOnRefresh: true,
          onUpdate: (self) => {
            const totalSteps = triggers.length - 1;
            const rawProgress = self.progress * totalSteps;
            const index = Math.min(totalSteps, Math.floor(rawProgress));
            const segmentProgress = (rawProgress - index) * 100;

            setActive(index);

            triggers.forEach((trigger, i) => {
              if (i < index) {
                trigger.style.setProperty('--progress', '100%');
              } else if (i === index) {
                trigger.style.setProperty('--progress', `${segmentProgress}%`);
              } else {
                trigger.style.setProperty('--progress', '0%');
              }
            });
          },
        });

        return () => st.kill();
      });
    });

    // WOPR mobile slider
    const woprMobileSliders = document.querySelectorAll('.js-wopr-screens-mobile-slider');

    woprMobileSliders.forEach((slider) => {
      const mm = gsap.matchMedia();

      mm.add('(max-width: 1023px)', () => {
        if (!slider.classList.contains('slick-initialized')) {
          jQuery(slider).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            infinite: false,
            adaptiveHeight: false,
            swipe: true,
          });
        }

        return () => {
          if (slider.classList.contains('slick-initialized')) {
            jQuery(slider).slick('unslick');
          }
        };
      });
    });

    // =========================================================================
    // WOPR MARQUEE LOGO DRAW-STYLE REVEAL
    // =========================================================================

    const $woprMarqueeLogoWrap = $('.js-wopr-reveal .wopr-logo');

    if ($woprMarqueeLogoWrap.length) {
      const $woprMarqueeSvg = $woprMarqueeLogoWrap.find('svg');
      const $woprMarqueeClipRect = $woprMarqueeSvg.find('.js-wopr-logo-reveal-clip-rect');

      gsap.set($woprMarqueeLogoWrap, {
        autoAlpha: 1,
        filter: 'drop-shadow(0 0 0 rgba(255, 255, 255, 0))',
      });

      gsap.set($woprMarqueeClipRect, {
        attr: {
          width: 0,
        },
      });

      const woprMarqueeLogoDrawTimeline = gsap.timeline({
        delay: 0.25,
      });

      woprMarqueeLogoDrawTimeline.to($woprMarqueeClipRect, {
        attr: {
          width: 170.821,
        },
        duration: 1.45,
        ease: 'expo.out',
      });

      woprMarqueeLogoDrawTimeline.to($woprMarqueeLogoWrap, {
        filter: 'drop-shadow(0 0 16px rgba(255, 255, 255, 0.5))',
        duration: 0.25,
        repeat: 1,
        yoyo: true,
        ease: 'power1.out',
      }, '-=0.35');

      woprMarqueeLogoDrawTimeline.fromTo($woprMarqueeLogoWrap, {
        autoAlpha: 0.72,
      }, {
        autoAlpha: 1,
        duration: 0.04,
        repeat: 5,
        yoyo: true,
        ease: 'none',
      }, '-=0.2');
    }

    // WOPR marquee image/video parallax - large only
    const woprParallaxMM = gsap.matchMedia();

    woprParallaxMM.add('(min-width: 1024px)', () => {
      const animations = [];

      gsap.utils.toArray('.wopr-marquee__image-wrap').forEach((wrap) => {
        const media = wrap.querySelector('.wopr-marquee__image, .wopr-marquee__video');
        if (!media) return;

        const tween = gsap.fromTo(
          media,
          {
            y: 55,
            scale: 1.08,
          },
          {
            y: -55,
            scale: 1.08,
            ease: 'none',
            scrollTrigger: {
              trigger: wrap,
              start: 'top bottom',
              end: 'bottom top',
              scrub: 0.8,
              invalidateOnRefresh: true,
            },
          }
        );

        animations.push(tween);
      });

      return () => {
        animations.forEach((tween) => {
          if (tween.scrollTrigger) tween.scrollTrigger.kill();
          tween.kill();
        });

        gsap.set('.wopr-marquee__image, .wopr-marquee__video', {
          clearProps: 'transform',
        });
      };
    });

    // =========================================================================
    // WOPR BACKGROUND GRADIENT COLOR SHIFT
    // =========================================================================

    const $woprGradientField = $('.js-wopr-gradient-field');

    if ($woprGradientField.length) {
      const $woprGradientSvg = $woprGradientField.find('svg');
      const $woprPrimaryGradient = $woprGradientSvg.find('#paint0_linear_2060_258');
      const $woprPrimaryGradientStops = $woprPrimaryGradient.find('stop');

      const woprGradientColorTimeline = gsap.timeline({
        repeat: -1,
        yoyo: true,
        defaults: {
          ease: 'sine.inOut',
        },
      });

      woprGradientColorTimeline.to($woprPrimaryGradient, {
        attr: {
          y1: 62,
          y2: 370,
        },
        duration: 6,
      }, 0);

      woprGradientColorTimeline.to($woprPrimaryGradientStops.eq(1), {
        attr: {
          offset: 0.12,
        },
        duration: 5,
      }, 0);

      woprGradientColorTimeline.to($woprPrimaryGradientStops.eq(2), {
        attr: {
          offset: 0.34,
        },
        duration: 6.5,
      }, 0);

      woprGradientColorTimeline.to($woprPrimaryGradientStops.eq(3), {
        attr: {
          offset: 0.43,
        },
        duration: 5.8,
      }, 0);

      woprGradientColorTimeline.to($woprPrimaryGradientStops.eq(5), {
        attr: {
          offset: 0.63,
        },
        duration: 7,
      }, 0);

      woprGradientColorTimeline.to($woprPrimaryGradientStops.eq(6), {
        attr: {
          offset: 0.74,
        },
        duration: 6.2,
      }, 0);

      woprGradientColorTimeline.to($woprPrimaryGradientStops.eq(7), {
        attr: {
          offset: 0.92,
        },
        duration: 7.5,
      }, 0);
    }

    // =========================================================================
// WOPR STATS COUNT / SCRAMBLE ANIMATION
// =========================================================================

const $woprStats = $('.stats');

if ($woprStats.length) {
  const woprFormatNumberWithCommas = (numberValue) => {
    return numberValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  const woprGetStatNumberData = ($statElement) => {
    const statOriginalHtml = $statElement.html();
    const statOriginalText = $statElement.text();
    const statNumberString = statOriginalText.replace(/[^\d]/g, '');
    const statNumberValue = parseInt(statNumberString, 10);

    return {
      statOriginalHtml,
      statNumberString,
      statNumberValue,
      statNumberLength: statNumberString.length,
    };
  };

  const woprBuildFinalStatHtml = ($statElement, finalNumberString) => {
    const statOriginalHtml = $statElement.html();
    const formattedFinalNumber = woprFormatNumberWithCommas(finalNumberString);

    return statOriginalHtml.replace(/\d[\d,]*/, formattedFinalNumber);
  };

  const woprBuildScrambledNumber = (numberLength) => {
    let scrambledNumber = '';

    for (let numberIndex = 0; numberIndex < numberLength; numberIndex += 1) {
      scrambledNumber += Math.floor(Math.random() * 10);
    }

    return woprFormatNumberWithCommas(scrambledNumber);
  };

  const woprAnimateShortStat = ($statElement, statData) => {
    const countProxy = {
      value: 0,
    };

    gsap.to(countProxy, {
      value: statData.statNumberValue,
      duration: 1.25,
      ease: 'power3.out',
      onUpdate: function () {
        const currentCountValue = Math.round(countProxy.value);
        const currentFormattedValue = woprFormatNumberWithCommas(currentCountValue);

        $statElement.html(
          statData.statOriginalHtml.replace(/\d[\d,]*/, currentFormattedValue)
        );
      },
      onComplete: function () {
        $statElement.html(
          woprBuildFinalStatHtml($statElement, statData.statNumberString)
        );
      },
    });
  };

  const woprAnimateLongStat = ($statElement, statData) => {
  const scrambleProxy = {
    progress: 0,
  };

  const finalFormattedNumber = woprFormatNumberWithCommas(statData.statNumberString);
  const finalFormattedLength = finalFormattedNumber.length;

  gsap.to(scrambleProxy, {
    progress: 1,
    duration: 1.55,
    ease: 'power4.out',
    onUpdate: function () {
      const visibleCharacterCount = Math.max(
        1,
        Math.ceil(finalFormattedLength * scrambleProxy.progress)
      );

      const visibleNumberLength = finalFormattedNumber
        .slice(0, visibleCharacterCount)
        .replace(/[^\d]/g, '')
        .length;

      const scrambledNumber = woprBuildScrambledNumber(visibleNumberLength);
      const scrambledNumberPadded = scrambledNumber.slice(0, visibleCharacterCount);

      $statElement.html(
        statData.statOriginalHtml.replace(/\d[\d,]*/, scrambledNumberPadded)
      );
    },
    onComplete: function () {
      $statElement.html(
        statData.statOriginalHtml.replace(/\d[\d,]*/, finalFormattedNumber)
      );
    },
  });
};

  const woprRunStatsAnimation = () => {
    $('.stats .the-stat').each(function () {
      const $statElement = $(this);

      if ($statElement.hasClass('is-animated')) {
        return;
      }

      const statData = woprGetStatNumberData($statElement);

      if (!statData.statNumberString) {
        return;
      }

      $statElement.addClass('is-animated');

      if (statData.statNumberLength >= 6) {
        woprAnimateLongStat($statElement, statData);
      } else {
        woprAnimateShortStat($statElement, statData);
      }
    });
  };

  gsap.fromTo('.stats .the-stat',
    {
      autoAlpha: 0,
      y: 16,
    },
    {
      autoAlpha: 1,
      y: 0,
      duration: 0.45,
      stagger: 0.12,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: '.stats',
        start: 'top 80%',
        once: true,
        onEnter: woprRunStatsAnimation,
      },
    }
  );
}

  // WOPR stat counters
const woprCounters = document.querySelectorAll('.js-wopr-counter');

woprCounters.forEach((counter) => {
  const original = counter.dataset.count || counter.textContent.trim();
  const number = parseFloat(original.replace(/[^\d.]/g, ''));

  const prefixMatch = original.match(/^\D+/);
  const suffixMatch = original.match(/[^\d.]+$/);

  const prefix = prefixMatch ? prefixMatch[0] : '';
  const suffix = suffixMatch ? suffixMatch[0] : '';

  if (Number.isNaN(number)) return;

  ScrollTrigger.create({
    trigger: counter.closest('.wopr-cards-section'),
    start: 'top 70%',
    once: true,
    onEnter: () => {
      gsap.fromTo(
        counter,
        { innerText: 0 },
        {
          innerText: number,
          duration: 1.6,
          ease: 'power2.out',
          snap: { innerText: number % 1 === 0 ? 1 : 0.1 },
          onUpdate() {
            const current = parseFloat(counter.innerText);
            const formatted = number % 1 === 0 ? Math.round(current) : current.toFixed(1);
            counter.textContent = `${prefix}${formatted}${suffix}`;
          },
          onComplete() {
            counter.textContent = original;
          },
        }
      );
    },
  });
});
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
